import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useSeo } from "../lib/seo";
import { ArticleGrid } from "../components/articles/ArticleCard";
import { Pagination } from "../components/common/Pagination";
import { PageLoader } from "../components/common/States";
import NotFound from "./NotFound";

export default function AuthorPage() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const page = Number(params.get("page") || 1);
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    api.get(`/authors/${slug}`, { params: { page } }).then((r) => { setData(r.data); setStatus("ok"); }).catch((e) => setStatus(e?.response?.status === 404 ? "404" : "error"));
  }, [slug, page]);

  const author = data?.author;
  useSeo({ title: author?.name, description: author?.bio, path: `/author/${slug}/`, robots: page > 1 ? "noindex,follow" : "index,follow" });

  if (status === "404") return <NotFound />;
  if (status !== "ok") return <PageLoader />;

  return (
    <div className="container-ab py-14 lg:py-20">
      <header className="grid items-center gap-8 md:grid-cols-12" data-testid="author-header">
        <div className="md:col-span-2"><div className="flex aspect-square w-32 items-center justify-center rounded-3xl bg-ab-accent font-serif text-4xl font-semibold text-white">AB</div></div>
        <div className="md:col-span-10">
          <p className="eyebrow">{author.role}</p>
          <h1 className="mt-2 font-serif text-4xl font-semibold tracking-tight sm:text-5xl" data-testid="author-name">{author.name}</h1>
          <p className="mt-4 max-w-3xl text-lg text-ab-text-2">{author.bio}</p>
          {data.expertise.length > 0 && (
            <ul className="mt-5 flex flex-wrap gap-2" aria-label="Category expertise" data-testid="author-expertise">
              {data.expertise.map((e) => <li key={e.category} className="rounded-full bg-ab-accent-soft px-3.5 py-1.5 text-xs font-semibold text-[#24583E]">{e.category} · {e.count}</li>)}
            </ul>
          )}
        </div>
      </header>
      <section className="mt-16" aria-labelledby="author-articles-heading">
        <h2 id="author-articles-heading" className="font-serif text-3xl font-semibold">Recent articles</h2>
        <div className="mt-8"><ArticleGrid articles={data.articles.items} /></div>
        <Pagination page={data.articles.page} pages={data.articles.pages} buildHref={(n) => `/author/${slug}/?page=${n}`} />
      </section>
    </div>
  );
}
